export default __webpack_public_path__ + "static/media/overview_grey.3826c83d.svg";